import { Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';
import { Button, Link, TextField } from '@material-ui/core';
import * as Styled from './Login.styled';
import { SiteComponent } from '../SiteComponentPlugin';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import { useSiteContext } from '../../SiteContext';
import SiteConfigLogin from './SiteConfigLogin';
const validationSchema = Yup.object().shape({
    email: Yup.string()
        .email('Invalid e-mail address.')
        .required('E-mail address is required.')
});
export const SiteForgotPassword = props => {
    const component = useSubscribeComponentChanges(SiteForgotPasswordPlugin, props);
    const { title, buttonText, textLink } = component.props || {};
    const classes = ['site-forgot-password'];
    const { isHover, hoverProps } = useSiteContext();
    if (isHover(component)) {
        classes.push('component-hover');
    }
    //   const { success, isLoading, error, doPasswordRecover } = usePasswordRecover();
    //   let errorMessage = error
    //     ? 'Unable to send reset password. Please double check your credentials.'
    //     : undefined;
    const handleSubmit = (form) => {
        // errorMessage = undefined;
        // doPasswordRecover(form.email);
    };
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteForgotPasswordPlugin }, props),
        React.createElement(Styled.StyledLoginContainer, Object.assign({ className: classes.join(' ') }, hoverProps(component)),
            React.createElement(Styled.StyledLoginCard, null,
                React.createElement("img", { src: '/assets/sl-logo@2x.png', alt: 'Sierra Labs', className: 'logo' }),
                React.createElement("h2", null, title ? title : 'Password Recover'),
                React.createElement(Formik, { initialValues: { email: '' }, validationSchema: validationSchema, validateOnBlur: true, onSubmit: handleSubmit }, ({ values, errors, touched, handleChange, handleBlur }) => (React.createElement(Styled.StyledLoginForm, null,
                    React.createElement(TextField, { variant: 'outlined', type: 'email', name: 'email', label: 'Email', className: 'form-field', placeholder: 'Specify your email to reset', onChange: handleChange, onBlur: handleBlur, 
                        //   disabled={isLoading}
                        value: values.email, error: touched.email && !!errors.email, helperText: errors.email }),
                    React.createElement(Button, { type: 'submit', variant: 'contained', disableElevation: true }, buttonText ? buttonText : 'Reset Button Label')))),
                React.createElement(Link, { className: 'forgot-password-link' }, textLink ? textLink : 'Back to Login Link Label')))));
};
export const SiteForgotPasswordPlugin = {
    name: 'Site Forgot Password',
    type: 'site-forgot-password',
    component: SiteForgotPassword,
    configurator: SiteConfigLogin,
    initConfig: component => {
        if (!component.props)
            component.props = {};
        component.props.title = 'Password Recover';
        component.props.buttonText = 'Reset Button Label';
        component.props.textLink = 'Back to Login Link Label';
        return component;
    }
};
//# sourceMappingURL=SiteForgotPasswordPlugin.js.map